import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeTableCellSkeleton } from './TypeTableCell'
import type { TypeTableRowSkeleton } from './TypeTableRow'

export interface TypeComponentTableFields {
  internalName: EntryFieldTypes.Symbol
  title?: EntryFieldTypes.Symbol
  subtext?: EntryFieldTypes.Symbol
  tableStyle?: EntryFieldTypes.Symbol<'Default' | 'Levels'>
  stickySections?: EntryFieldTypes.Array<EntryFieldTypes.Symbol<'First Column' | 'Header'>>
  headers?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeTableCellSkeleton>>
  rows?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeTableRowSkeleton>>
  footer?: EntryFieldTypes.EntryLink<TypeTableRowSkeleton>
  size?: EntryFieldTypes.Symbol<'Medium' | 'Small'>
}

export type TypeComponentTableSkeleton = EntrySkeletonType<TypeComponentTableFields, 'componentTable'>
export type TypeComponentTable<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentTableSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentTable<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentTable<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentTable'
}
